export default __webpack_public_path__ + "static/media/moveo_logo.e596a960.svg";